module.exports = __webpack_public_path__ + "img/3-01.8d122f8c.png";